import { isAsyncIterable } from './utils/iterator.js';
export function map(fn) {
    return function mapFn(data) {
        if (data == null)
            return;
        // Handle the async version
        if (isAsyncIterable(data) || data instanceof Promise) {
            return {
                async *[Symbol.asyncIterator]() {
                    let stream = data instanceof Promise ? await data : data;
                    let i = 0;
                    for await (let datum of stream)
                        yield fn(datum, i++);
                },
            };
        }
        // Handle the sync version
        return {
            *[Symbol.iterator]() {
                let i = 0;
                for (let datum of data)
                    yield fn(datum, i++);
            },
        };
    };
}
